export default {
	cnae: {
		cod: '',
		desc: '',
	},
	grauRisco: 1,
	cipa: {
		grupo: '',
		atividade_economica: '',
		membros: 0,
	},
	efetivo: '',
	suplente: '',
	tecnico: {
		editor: '',
		registro: '',
		qualificacao: 'TST',
	},
};



// WEBPACK FOOTER //
// ./src/components/order-of-service/components/actions-components/js/reset.js